/** `AAAA-MM-JJ` → `JJ/MM/AAAA`. */
export function jourLisible(iso: string): string {
  const [annee, mois, jour] = iso.slice(0, 10).split('-');
  return `${jour}/${mois}/${annee}`;
}

/** Jour civil réunionnais du jour, `AAAA-MM-JJ`. */
export function aujourdhuiReunion(): string {
  return new Date().toLocaleDateString('sv-SE', { timeZone: 'Indian/Reunion' });
}
